// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"77f8d482","52":"69f19253","63":"07e1e45f","119":"e499c952","452":"0e6e4cb9","522":"0d424c23","686":"1e09ef52","728":"74978ac6","792":"31fda0c8","794":"46c687dd","803":"7e7166d9"}[chunkId] + ".chunk.js";
};